// ─── Freeform Studio V1 ───────────────────────────────────────
// A true freeform canvas — like Illustrator/Canva. One single
// tall canvas, no hero/content/footer boundaries. Mobile-first
// (375px). Drop images, text, and widgets anywhere.

export const freeformStudioV1 = {
  templateId: 'freeform-studio-v1',
  name: 'Studio',
  description: 'Freeform canvas. Design like Canva — drag images, text, and widgets anywhere.',
  category: 'studio',
  previewColors: ['#ffffff', '#1a1a1a', '#3b82f6'],
  isCollage: true,
  isUniversal: true,
  isStudio: true,
  theme: {
    palette: 'ivory-gold',
    fontPair: 'playfair-inter',
    radius: 'soft',
    shadow: 'soft',
    overlay: 'none',
    themeExtensions: {
      paper: '#ffffff',
      monoFont: '"Courier New", monospace',
      handFont: '"Caveat", cursive',
    },
  },
  settings: {
    rsvpEnabled: true,
  },
  sections: [
    {
      id: 'canvas-main',
      type: 'collage',
      label: 'Canvas',
      visible: true,
      height: { mobile: 1600, desktop: 1600 },
      background: { type: 'color', color: '#ffffff' },
      editableRules: { fields: ['elements', 'background', 'height'], locked: [] },
      data: {},
      elements: [],
    },
  ],
};
